
import { Axios as http } from '@/js/AxiosPlugin'

export class ApiClient {
  // ------------------------------- 会员 ------------------------------
  DO_CREATE_VIP(vip) {
    return http.post('/api/Users', vip)
  }

  DO_RECHARGE(userID, fee) {
    console.log(fee)
    return http.post('/api/Users/Recharge/' + userID, fee)
  }

  DO_GET_ALL_USERS() {
    return http.get('/api/Users')
  }

  DO_GET_USER_LIST(pageIndex) {
    return http.get('/api/Users/' + pageIndex)
  }

  DO_SEARCH(key) {
    return http.get('/api/Users?filter=' + key)
  }

  DO_USER_VIEW(phone) {
    return http.get('/api/Users/' + phone)
  }

  DO_UPDATE_USER_PROFILE(user) {
    return http.put(`/api/Users/${user.id}`, user.profile)
  }
  // ------------------------------- 洗衣单 ------------------------------
  DO_CREATE_TICKET(ticket) {
    return http.post('/api/Tickets', ticket)
  }

  DO_GET_TICKET_LIST(pageIndex) {
    return http.get(`/api/Tickets?pageIndex=${pageIndex}`)
  }

  DO_PAY_TICKET(ticketID, fee) {
    return http.post('/api/Tickets/PayTicket/' + ticketID, fee)
  }

  DO_PAY_CLOTHE(clotheRecordID, fee) {
    return http.post('/api/Tickets/PayClothe/' + clotheRecordID, fee)
  }

  DO_TAKE_OFF_TICKET(ticketID) {
    return http.post('/api/Tickets/TakeOff/' + ticketID)
  }

  DO_TAKE_OFF_CLOTHE(clotheRecordID) {
    return http.post('/api/Tickets/TakOffClothe/' + clotheRecordID)
  }

  DO_GET_TICKET(ticketID) {
    return http.get('/api/Tickets/' + ticketID)
  }

  // ---------------------品牌------------------------//
  ORDER_BRANDS(items) {
    return http.post('/api/Brands/OrderBrands', {
      items: items
    })
  }

  ORDER_COLORS(items) {
    return http.post('/api/Colors/OrderColors', {
      items: items
    })
  }

  ORDER_PRICES(items) {
    return http.post('/api/Prices/OrderPrices', {
      items: items
    })
  }

  ORDER_FLAWS(items) {
    return http.post('/api/Flaws/OrderFlaws', {
      items: items
    })
  }

  DO_GET_ALL_BRANDS() {
    return http.get(`/api/Brands?pageSize=1000`)
  }

  DO_GET_BRANDS_SELECTOR_HEADERS() {
    return http.get('/api/Brands/Selector/Headers')
  }

  DO_GET_BRANDS_SEARCH_BY_SELECTOR_HEADER(header) {
    return http.get('/api/Brands/Selector/Search/' + header)
  }

  DO_ADD_BRAND(brand) {
    return http.post('/api/Brands', brand)
  }

  // ---------------------颜色------------------------//
  DO_GET_ALL_COLORS() {
    return http.get(`/api/Colors?pageSize=1000`)
  }

  DO_ADD_COLOR (color) {
    return http.post('/api/Colors', color)
  }

  DO_GET_COLORS_SELECTOR_HEADERS() {
    return http.get('/api/Colors/Selector/Headers')
  }

  DO_GET_COLORS_SEARCH_BY_SELECTOR_HEADER(header) {
    return http.get('/api/Colors/Selector/Search/' + header)
  }

  // ---------------------瑕疵------------------------//
  DO_GET_ALL_FLAWS() {
    return http.get('/api/Flaws?pageSize=1000')
  }

  DO_GET_FLAWS_SELECTOR_HEADERS() {
    return http.get('/api/Flaws/Selector/Headers')
  }

  DO_GET_FLAWS_SEARCH_BY_SELECTOR_HEADER(header) {
    return http.get('/api/Flaws/Selector/Search/' + header)
  }

  DO_ADD_FLAW(flaw) {
    return http.post('/api/Flaws', flaw)
  }

  // ---------------------价格------------------------//
  DO_GET_ALL_PRICES() {
    return http.get('/api/Prices?pageSize=1000')
  }

  DO_GET_PRICES_SELECTOR_HEADERS() {
    return http.get('/api/Prices/Selector/Headers')
  }

  DO_GET_PRICES_SEARCH_BY_SELECTOR_HEADER(header) {
    return http.get('/api/Prices/Selector/Search/' + header)
  }

  DO_ADD_CLOTHE_PRICE(data) {
    return http.post('/api/Prices', data)
  }

  // ---------------------Vip-------------------------//
  DO_GET_ACCOUNT_RECORD(idView) {
    return http.get('/api/Vip/AccountRecord/' + idView)
  }

  DO_GET_ACCOUNT_RECORD_LIST(userID) {
    return http.get('/api/Vip/AccountRecords/' + userID)
  }

  DO_LOGIN(playload) {
    return http.post('/api/Auth', playload)
  }

  DO_GET_NOTIFICATIONS (pageIndex) {
    return http.get(`/api/Notifications?pageIndex=${pageIndex}`)
  }

  DO_READ_NOTIFICATION(notificationId) {
    return http.get(`/api/Notifications/${notificationId}`)
  }

  DO_GET_CLOTHE(id) {
    return http.get(`/api/Clothe/${id}`)
  }

  DO_CREATE_VERSION(data) {
    return http.post(`/api/versions`, data)
  }

  DO_UPDATE_VERSION(data) {
    return http.put(`/api/versions/${data.id}`, data)
  }

  DO_DELETE_VERSION(data) {
    return http.delete(`/api/versions/${data.id}`)
  }

  DO_GET_VERSIONS(data) {
    return http.get(`/api/versions?name=Laundry15.Desktop`)
  }
}

export default new ApiClient()



// WEBPACK FOOTER //
// ./src/api/index.js